import React from "react";
import Layout from "../Navbar";
import BackToUnified from "../sideBar/backToUnified.js";
import { useTheme } from "../../Context/Theme";

const HelpSupport = () => {
  const { themeData } = useTheme();
  return (
    <>
      <Layout noToggle={false}>
        {/* <div className="w-full px-4 py-12 mx-auto max-w-7xl"> */}
        <div className="w-full  mx-auto max-w-7xl flex flex-col justify-center items-center my-20 lg:my-0 lg:min-h-[calc(100dvh-66px)]  overflow-auto ">
          <h1 className="mb-12 text-4xl font-bold text-center text-navy-900">
            Help & Support
          </h1>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {/* Phone Support Card */}
            <div className="flex flex-col items-center p-8 text-center bg-gray-100 rounded-lg">
              <div className="relative w-16 h-16 mb-6">
                <div className="absolute inset-0 flex items-center justify-center bg-blue-600 rounded-full">
                  <div className="absolute right-0 w-8 h-8 bg-yellow-400 rounded-full -top-1" />
                  <div className="w-6 h-6 bg-white rounded-full" />
                </div>
              </div>

              <a
                href="tel:+91-22-42792110"
                className="mb-4 text-xl font-semibold text-blue-600 hover:underline"
              >
                +91-22-42792110
              </a>

              <p className="mb-2 text-gray-600">Available</p>
              <p className="text-gray-600">
                10 AM to 11 PM IST - Monday to Friday
              </p>
              <p className="text-gray-600">
                8 AM to 5 PM IST - Weekends/US Holidays
              </p>
            </div>

            {/* Email Support Card */}
            <div className="flex flex-col items-center p-8 text-center bg-gray-100 rounded-lg">
              <div className="relative w-16 h-16 mb-6">
                <div className="flex items-center justify-center w-16 h-12 bg-blue-600 rounded-lg">
                  <div className="relative w-12 h-8 bg-gray-200 rounded">
                    <div className="absolute right-0 w-2 h-2 bg-yellow-400 -top-1" />
                  </div>
                </div>
              </div>

              <a
                href={`mailto:${themeData?.data?.senderEmail}`}
                className="mb-4 text-xl font-semibold text-blue-600 hover:underline"
              >
                {themeData?.data?.senderEmail}
              </a>

              <p className="text-gray-600">Responses within 48 hours</p>
            </div>
          </div>
        </div>
      </Layout>
      <BackToUnified />
    </>
  );
};

export default HelpSupport;
